/*
 * Bravo · Recuperar la posición en la colección al volver de una ficha.
 *
 * Con el scroll infinito, al volver atrás desde una ficha el navegador recarga la
 * colección con solo la primera página (24 productos) e intenta colocar el scroll donde
 * estaba, en una lista que ya no mide lo mismo. Esto lo arregla:
 *   - Al salir de la colección guarda cuántas páginas había cargadas, la altura del
 *     scroll y la ficha que se tocó.
 *   - Al volver atrás (solo entonces) pide de nuevo las páginas que faltan, las añade a
 *     la lista y deja el scroll en la ficha de la que se venía.
 *
 * Los productos se vuelven a pedir a Shopify, no se guardan: precio y stock salen al día.
 * Si el navegador devuelve la página intacta (bfcache) no hace nada, porque no hace falta.
 * Lo guardado caduca a los 30 minutos y va por URL, así que respeta filtros y orden.
 *
 * Para revisarlo en el navegador (DevTools):
 *   - Application → Session Storage: bravo-collection-restore (se puede borrar sin problema).
 *   - Network, filtro "section_id": una petición por cada página recuperada.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var STORE = 'bravo-collection-restore';
  var MAX_AGE = 30 * 60 * 1000;
  var MAX_PAGES = 20;

  var grid = document.querySelector('#AjaxinateLoop');
  var pagination = document.querySelector('#AjaxinatePagination');
  if (!grid || !pagination) return;

  var sectionId = grid.dataset.ajaxinateId;
  var initialCount = countProducts();
  var clicked = null;

  function countProducts() {
    return grid.querySelectorAll('[data-product-block]').length;
  }

  function pageKey() {
    return window.location.pathname + window.location.search;
  }

  function read() {
    try {
      var state = JSON.parse(sessionStorage.getItem(STORE));
      if (state && state.key === pageKey() && Date.now() - state.ts < MAX_AGE) return state;
    } catch (e) {}
    return null;
  }

  function loadedPages() {
    var next = pagination.querySelector('a');
    if (next) {
      var page = Number(new URL(next.href, window.location.href).searchParams.get('page'));
      if (page > 1) return page - 1;
    }
    return initialCount > 0 ? Math.ceil(countProducts() / initialCount) : 1;
  }

  function save() {
    var state = {
      key: pageKey(),
      ts: Date.now(),
      pages: loadedPages(),
      y: window.scrollY,
    };
    if (clicked && clicked.isConnected) {
      state.href = clicked.getAttribute('href');
      state.offset = clicked.getBoundingClientRect().top;
    }
    try {
      sessionStorage.setItem(STORE, JSON.stringify(state));
    } catch (e) {}
  }

  grid.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href*="/products/"]');
      if (link) clicked = link;
    },
    true
  );
  window.addEventListener('pagehide', save);

  function fetchPage(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', page);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function scrollToSaved(state) {
    var top = state.y;
    if (state.href) {
      var link = grid.querySelector('a[href="' + CSS.escape(state.href) + '"]');
      if (link) top = link.getBoundingClientRect().top + window.scrollY - state.offset;
    }
    window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  }

  function restore(state) {
    var userMoved = false;
    function onUserMove() {
      userMoved = true;
    }
    ['touchstart', 'wheel', 'keydown'].forEach(function (type) {
      window.addEventListener(type, onUserMove, { once: true, passive: true });
    });

    // La lista se va recolocando mientras cargan imágenes y apps: se repite el ajuste
    // unas cuantas veces, y se deja en cuanto la persona mueve la página.
    function settle() {
      var tries = 0;
      (function again() {
        if (userMoved) return;
        scrollToSaved(state);
        if (++tries < 6) setTimeout(again, 250);
      })();
    }

    var pages = Math.min(state.pages, MAX_PAGES);
    if (pages < 2) return settle();

    var requests = [];
    for (var page = 2; page <= pages; page++) requests.push(fetchPage(page));

    Promise.all(requests)
      .then(function (docs) {
        // Si el scroll infinito ya ha cargado algo por su cuenta, no se duplica.
        if (countProducts() !== initialCount) return;

        var html = '';
        var lastPagination = null;
        docs.forEach(function (doc) {
          var pageGrid = doc.querySelector('#AjaxinateLoop');
          if (!pageGrid) return;
          pageGrid.querySelectorAll('[data-product-block]').forEach(function (item) {
            item.classList.add('loaded-item');
          });
          html += pageGrid.innerHTML;
          lastPagination = doc.querySelector('#AjaxinatePagination');
        });
        if (!html) return;

        grid.insertAdjacentHTML('beforeend', html);
        pagination.innerHTML = lastPagination ? lastPagination.innerHTML : '';

        var items = grid.closest('ajaxinate-items');
        if (items && typeof items.reinit === 'function') items.reinit();
      })
      .catch(function () {})
      .then(settle);
  }

  var navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var state = navigation && navigation.type === 'back_forward' ? read() : null;
  if (!state) return;

  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  restore(state);
})();
